var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42054 3.48615L6.93458 8.0002L2.42056 12.5142C2.27932 12.6555 2.19995 12.8471 2.19995 13.0469C2.19995 13.2467 2.27929 13.4383 2.42052 13.5796C2.56181 13.7208 2.75343 13.8002 2.95322 13.8002C3.15301 13.8002 3.34463 13.7208 3.48593 13.5796L7.99995 9.06556L12.514 13.5796C12.6553 13.7208 12.8469 13.8002 13.0467 13.8002C13.2465 13.8002 13.4381 13.7209 13.5793 13.5796C13.7206 13.4383 13.8 13.2467 13.8 13.0469C13.8 12.8471 13.7206 12.6555 13.5793 12.5142L9.06532 8.0002L13.5793 3.48617C13.7206 3.34487 13.8 3.15326 13.8 2.95346C13.8 2.75367 13.7206 2.56206 13.5793 2.42076C13.4381 2.27953 13.2465 2.2002 13.0467 2.2002C12.8469 2.2002 12.6553 2.27954 12.514 2.42078L7.99995 6.93483L3.48593 2.4208C3.34463 2.27956 3.153 2.2002 2.95322 2.2002C2.75345 2.2002 2.56185 2.27953 2.42056 2.42076C2.27933 2.56205 2.19995 2.75369 2.19995 2.95346C2.19995 3.15325 2.2793 3.34485 2.42054 3.48615Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxClose);
export default __webpack_public_path__ + "static/media/tx-close.c0cbcbce4a1f8b7cb185f1ad2f821ae0.svg";
export { ForwardRef as ReactComponent };